import classNames from 'classnames/bind';

import { isStreamable } from 'services/stream';
import { useFile } from 'files/hooks/useFile';
import { useStream } from 'streams/hooks/useStream';

import { Loader } from 'components/Loader/Loader';
import { MediaPreview } from 'components/MediaPreview/MediaPreview';
import { Text } from 'components/Text/Text';

import styles from './CameraDetailStreams.module.scss';

const c = classNames.bind(styles);

type StreamSnapshotListElementProps = {
  streamId: string;
};

export function StreamSnapshotListElement({
  streamId,
}: StreamSnapshotListElementProps) {
  const { data: stream } = useStream(streamId);

  const { data: file, error, isLoading } = useFile(stream?.snapshot_file_id);
  const url = file?.data_url;

  function preview() {
    if (!stream || error || stream.status === 'offline') {
      return specialCases();
    }

    return (
      <>
        {file && url && <img className={c('img-preview')} src={url} alt="" />}

        {isLoading && (
          <div className={c('img-spinner')}>
            <span className="loading-spinner small" />
          </div>
        )}
      </>
    );
  }

  function specialCases() {
    if (!stream) {
      return <Loader text="Loading streams..." size="small" />;
    }

    if (error) {
      if (error.status === 400) {
        error.message = 'Snapshot not available.';
      }

      return (
        <div>
          <Text className={c('img-info')}>
            {error.message ||
              'An unknown error occurred. Please try again later.'}
          </Text>
        </div>
      );
    }

    if (stream.status === 'offline') {
      return (
        <div>
          <Text className={c('img-info')}>Stream is unavailable.</Text>
        </div>
      );
    }
  }

  return (
    <div className={c('stack')}>
      {preview()}
      {stream && isStreamable(stream) && (
        <MediaPreview className={c('mediapreview-wrap')} stream={stream} />
      )}
    </div>
  );
}
